<template>
    <div>



            <div class="card  abtg__default-card abtg__orangeborder-bottom" v-show="showAuctionPartialArchiveCard">
                <div class="card-head">
                    <header >{{$t('auction.label_title')}} {{this.CHANGE_REGION_NAME(regionCode)}}</header>
                    <div class="abtg__header_popover">
                        <popover module="auction" content="archive" color="white" position="left"></popover>
                    </div>
                    <div class="tools">

                    </div>
                </div>
                <div class="card-body abtg__table-border">


                    <div class="table-responsive">
                        <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded abtg__table-noborder">
                            <thead>
                            <tr>

                                <th class="mdl-data-table__cell--non-numeric text-left">
                                    <span class="abtg__text-abtg">{{$t('auction.label_city')}}</span>
                                </th>

                                <th class="mdl-data-table__cell--non-numeric text-left"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="au in auctionArchiveData">
                                <td><strong>{{au.city}}</strong></td>
                                <td>
                                    <div class="text-right" role="group" aria-label="Basic example">
                                        <a
                                           @click="triggerAuctionList(au.city_id, au.city)">
                                            <i class="fas fa-list  "></i></a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a
                                           data-toggle="modal" data-target="#exampleModalMine"
                                           @click="setIdToDelete(au.city_id)">
                                            <i class="far fa-trash-alt  "></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <!-- start modal -->
            <div class="modal fade" id="exampleModalMine" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="exampleModalLabel">
                                {{$t('valutation.valutation_question_title')}}</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {{$t('valutation.valutation_question_delete')}}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{$t('valutation.valutation_label_button_close')}}
                            </button>
                            <button type="button" class="btn btn-success"
                                    @click="deleteAllAuctionInTheCity()"
                                    data-dismiss="modal">{{$t('valutation.valutation_label_button_delete')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end modal -->

    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper';
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import Popover from '../commons/popover';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });
    export default {
        mixins: [mixin],
        components: {Money, Popover},
        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['showAuctionPartialArchiveCard', 'auctionArchiveData', 'regionCode', 'idToDelete']),
        },
        created: function () {


        },
        methods: {
            triggerAuctionList: function(city_id, city)
            {
                this.$store.dispatch('auction/auctionListByCity', {city_id: city_id, city: city, color: 0});
            },

            setIdToDelete: function(city_id)
            {
                this.idToDelete = city_id;
            },

            deleteAllAuctionInTheCity: function()
            {
                this.$store.dispatch('auction/deleteAllAuctionInTheCity')
            },

        }
    }
</script>